// extracted by mini-css-extract-plugin
export var beige = "footer-module--beige--0e87e";
export var contactSection = "footer-module--contactSection--8b1dc";
export var copyYear = "footer-module--copyYear--c0416";
export var cta = "footer-module--cta--79a4c";
export var firstColumn = "footer-module--firstColumn--bb20e";
export var footer = "footer-module--footer--e5644";
export var footerItem = "footer-module--footerItem--7ae7d";
export var inputContainer = "footer-module--inputContainer--b122a";
export var inputLabel = "footer-module--inputLabel--c9310";
export var linksContainer = "footer-module--linksContainer--e4a38";
export var linksSection = "footer-module--linksSection--97415";
export var newsletter = "footer-module--newsletter--8ca1a";
export var newsletterEmail = "footer-module--newsletterEmail--6a1d0";
export var outerContainer = "footer-module--outerContainer--52233";
export var socials = "footer-module--socials--cf230";
export var version = "footer-module--version--0e58c";